import type { SearchResult } from "@mirage/service-dbx-api";
import { RelevanceRubric } from "./service/types";

export const getRelevanceRubricFromSearchResult = (result: SearchResult) => {
  if (result.fileTypeInfo?.id === "image" && result.previewUrl) {
    return RelevanceRubric.Image;
  }

  return RelevanceRubric.File;
};
